module.exports = __webpack_public_path__ + "img/play.e052cca4.svg";